import { cn } from '../../lib/cn';
import type { SOPRow } from '../../knowledgecenter/framework';

type Props = { sops?: SOPRow[] };

export function SOPManagementPanel({ sops = [] }: Props) {
  return (
    <div className="space-y-2">
      {sops.map((s) => (
        <div key={s.title} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{s.title}</p>
            <p className="mt-0.5 text-xs text-slate-500">{s.version} · review due {s.reviewDue} · {s.acknowledged} acknowledged</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            s.status === 'published' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
            'bg-warning-50 text-warning-700 dark:bg-warning-950 dark:text-warning-300',
          )}>
            {s.status.replace('_', ' ')}
          </span>
        </div>
      ))}
    </div>
  );
}
